// --- helpers ---
export const fileToDataUrl = (file: File): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = (): void => resolve(reader.result as string);
		reader.onerror = reject;
		reader.readAsDataURL(file); // yields "data:image/png;base64,AAAA..."
	});

export const ensureDataUrl = (val?: string | null): string | null => {
	if (!val) {
		return null;
	}

	return val.startsWith('data:') ? val : `data:image/*;base64,${val}`;
};

export const stripDataUrl = (val?: string | null): string | null => {
	if (!val) {
		return null;
	}

	const idx = val.indexOf('base64,');

	return idx >= 0 ? val.slice(idx + 'base64,'.length) : val;
};
